import React, { useEffect, useState } from 'react'
import { IconButton, Tooltip } from '@mui/material'

import Colors from 'utils/Colors'
import { ListAlt } from '@mui/icons-material'
import { Modal } from 'components'
import ApplicationLog from 'components/ApplicationLog'
import Button from '@mui/material/Button'
import styles from '../styles'


const ApplicationLogButton = ({ application, useTitle = false }) => {
  const [currentApplication, setCurrentApplication] = useState(null)
  const [logModal, setLogModal] = useState(false)

  useEffect(() => {
    if (currentApplication) setLogModal(true)
  }, [currentApplication])

  const handleCloseLogModal = () => {
    setLogModal(false)
    setCurrentApplication(null)
  }

  const classes = styles()

  const handleOpenLog = () => {
    setCurrentApplication(application)
  }

  const renderIconButton = () => (
    <IconButton
    onClick={() => handleOpenLog()}
    size="large"
  >
    <ListAlt
      style={{
        color: Colors.primaryColor,
        fontSize: 20,
      }}
    />
  </IconButton>
  )

  const renderLabeledButton = () => (
    
      <Button size='small' variant="outlined" onClick={() => handleOpenLog()} startIcon={ <ListAlt
        style={{
          color: Colors.primaryColor,
          fontSize: 20,
        }}
      />}>
        Logs
    </Button>
    
  )

  return (
    <React.Fragment>
      <Tooltip
        arrow
        placement="top"
        title={
          <b className={classes.tooltipText}>Visualizar os logs da aplicação</b>
        }
      >
       {useTitle ? renderLabeledButton() : renderIconButton()}
      </Tooltip>
      <Modal
        open={logModal}
        onClose={() => handleCloseLogModal()}
        title="Registro de atividades da aplicação"
      >
        <ApplicationLog applicationData={currentApplication} />
      </Modal>
    </React.Fragment>
  )
}

export default ApplicationLogButton
